'use client';

import { c as _c } from "react/compiler-runtime";
import arrowDown from '@images/svg/index/arrow-down.svg';
import arrowUp from '@images/svg/index/arrow-up.svg';
import ROUTES from '@lib/constants/routes';
import cn from 'classnames';
import { debounce } from 'lodash';
import Link from 'next/link';
import { useRef, useState } from 'react';
import SVG from 'react-inlinesvg';
import style from '../HeaderButtons.module.scss';
import { useHeaderColorScheme } from '../hooks/useIconWrapperStyle';
const DropDownStandartBlock = t0 => {
  const $ = _c(21);
  const {
    headerColorScheme,
    onClick
  } = t0;
  const [toggleDropDown, setToggleDropDown] = useState(false);
  const refButton = useRef(null);
  const refDropDown = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = debounce(setToggleDropDown, 60);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const debouncedToggleDropDown = t1;
  const headerBtnStyle = useHeaderColorScheme(headerColorScheme);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => debouncedToggleDropDown(true);
    t3 = () => debouncedToggleDropDown(false);
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== toggleDropDown) {
    t4 = () => debouncedToggleDropDown(!toggleDropDown);
    $[3] = toggleDropDown;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = toggleDropDown ? style.active : null;
  let t6;
  if ($[5] !== headerBtnStyle || $[6] !== t5) {
    t6 = cn(headerBtnStyle, style.headerDropDownButton, t5);
    $[5] = headerBtnStyle;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span>Выбрать квартиру</span>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== toggleDropDown) {
    t8 = toggleDropDown ? <span><SVG src={arrowUp.src} fill="white" className={style.svgArrows} /></span> : <span><SVG src={arrowDown.src} fill="black" className={style.svgArrows} /></span>;
    $[9] = toggleDropDown;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t4 || $[12] !== t6 || $[13] !== t8) {
    t9 = <button ref={refButton} onClick={t4} className={t6}>{t7}{t8}</button>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== onClick || $[16] !== toggleDropDown) {
    t10 = toggleDropDown && <div className={style.dropDownList} ref={refDropDown}><Link href={ROUTES.flats.visual.root} className={cn(style.link, style.dropdownLink)} onClick={onClick}><span>Визуальный выбор</span></Link><Link href={ROUTES.flats.list} className={cn(style.link, style.dropdownLink)} onClick={onClick}><span>Выбор по параметрам</span></Link></div>;
    $[15] = onClick;
    $[16] = toggleDropDown;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t9) {
    t11 = <div onMouseOver={t2} onMouseLeave={t3} onFocus={_temp} className={style.dropDownContainer}>{t9}{t10}</div>;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
};
export default DropDownStandartBlock;
function _temp() {
  return null;
}